import { ratesHeading } from './RatesHeading';

export const ratesHeadingForOrders = {
    ...ratesHeading,
    colId: 'orderRates',
};
